import {IconDisplay} from '../genericComponents/IconDisplay'
import {ItemTypeIconSourceMap} from './model/ItemType'

const ItemTypeChip = ({itemTypeLabel}: {itemTypeLabel: string}) => (
    <IconDisplay
        className="item-card-image"
        iconName={itemTypeLabel}
        iconSourceMap={ItemTypeIconSourceMap}
        iconLabel={`item nature ${itemTypeLabel}`}
    />
)

export default ItemTypeChip
